<template>
  <div v-if="contract_manager">
    <h1 class="main-header">
      <translate translate-context="contract_managers"
                 :translate-params="{id: contract_manager.id, name: contract_manager.name}">
        Contracts - Contract Manager #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardHeader>
        <h4 v-translate translate-context="contract_manager">Contracts</h4>
        <div class="card-header-actions">
          <CButton color="primary" @click="onCreateNewContract" v-translate
                   v-if="hasPerm('contract_manager.contract.create')">Create Contract
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody class="p-0">
        <Contracts :contract_manager="contract_manager" :rows="contract_manager.contracts" v-if="contract_manager.contracts" @createEvent="onCreateEvent"/>
      </CCardBody>
    </CCard>
    <CreateContractModal ref="create_contract_modal"/>
    <CreateEventModal ref="create_event_modal"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound} from "@/domain/core/exception/exceptions";
import CreateContractModal from "@/domain/contract_manager/components/CreateContractModal.vue";
import Contracts from "@/domain/contract_manager/components/Contracts.vue";
import CreateEventModal from "@/domain/contract_manager/components/CreateEventModal.vue";

export default {
  name: 'ContractsPage',
  components: {
    CreateEventModal,
    Contracts, 
    CreateContractModal
  },
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.id}),
        this.fetchContractManager(this.$route.params.id)
      ])
      await this.fetchContracts()
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
    ]),
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
      'fetchContracts',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onCreateNewContract() {
      this.$router.push({
        name: 'contract_manager.contract.create',
        params: {id: this.contract_manager.id}
      })
    },
    onCreateEvent(contract) {
      this.$refs.create_event_modal.open(contract)
    },
  }
}
</script>